import React, { useRef, useState } from "react";
import { message, Button, Form, Input, Row, Col, Modal } from "antd";
import { addBodyType, editBodyType } from "./BodytypeApi";

const AddBodyType = ({ isOpen, setIsOpen, from, Fill, apiCall, current }) => {
  const [form] = Form.useForm();
  const formRef = useRef(form);
  const [isLoading, setIsLoading] = useState(false);

  const createBodyType = (changedValues) => {
    setIsLoading(true);
    let payload = {
      name: changedValues.name,
    };
    addBodyType(payload)
      .then((response) => {
        if (response.data.status) {
          message.success({ content: response.data.message });
          apiCall(current);
          setIsOpen(false);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };
  const editBody = (changedValues) => {
    setIsLoading(true);
    let payload = {
      newBodyTypeName: changedValues.name,
    };
    editBodyType(payload, `${Fill.id}`)
      .then((response) => {
        if (response.data.status) {
          message.success({ content: response.data.message });
          apiCall(current);
          setIsOpen(false);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };
  const handleOk = () => {
    form
      .validateFields()
      .then((values) => {
        form.resetFields();
        createBodyType(values);
      })
      .catch((info) => {
        console.log("Validate Failed:", info);
      });
  };

  const handleCancel = () => {
    setIsOpen(false);
  };

  return (
    <Modal
      footer={null}
      visible={isOpen}
      onOk={handleOk}
      onCancel={handleCancel}
      title={from === "edit" ? "Edit Body Type " : "Add Body Type"}
    >
      <Form
        className="bg-rgbaprimary1 p-4 mt-4"
        layout="vertical"
        onFinishFailed={(err) => console.log(err)}
        onFinish={from === "add" ? createBodyType : editBody}
        form={form}
        ref={formRef}
        initialValues={
          from === "edit"
            ? {
                name: Fill.name,
              }
            : ""
        }
      >
        <Row className="grid grid-cols-1">
          <Col>
            <Form.Item
              name="name"
              label="Body Type Name"
              rules={[
                {
                  required: true,
                  message: "Please enter Body Type name",
                },
                {
                  message: "Please enter a valid Body Type name",
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
        </Row>
        <Row className="flex justify-between gap-4">
          <Form.Item className="mt-4">
            <Button
              className="bg-white text-rgbaprimary9  hover:!bg-rgbaprimary8 hover:!text-white hover:!border-none"
              htmlType="reset"
            >
              Cancel
            </Button>
          </Form.Item>
          <Form.Item className="mt-4">
            <Button
              className="bg-primary text-white  hover:!bg-rgbaprimary8 hover:!text-white hover:!border-none"
              htmlType="submit"
              disabled={isLoading}
              loading={isLoading}
            >
              {from === "edit" ? "Edit Body Type " : "   Create Body Type"}
            </Button>
          </Form.Item>
        </Row>
      </Form>
    </Modal>
  );
};

export default AddBodyType;
